import { apiClient } from '@/services/ApiClient.js'

export class SystemNotificationService {
  static getNotifications(query) {
    return apiClient
      .get('system-notifications', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getNotification(id) {
    return apiClient
      .get('system-notifications/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static createNotification(notification) {
    return apiClient
      .post('system-notifications', notification)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static updateNotification(id, notification) {
    return apiClient
      .patch('system-notifications/' + id, notification)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static deleteNotification(id) {
    return apiClient
      .delete('system-notifications/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
